import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Badge,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@wondermaps/ui";

interface POIHeatmapItem {
  poiId: string;
  poiName: string;
  category: string;
  count: number;
  tier: "hot" | "warm" | "cold" | "dead";
}

const TIER_COLORS: Record<string, string> = {
  hot: "bg-red-500 text-white",
  warm: "bg-orange-400 text-white",
  cold: "bg-blue-400 text-white",
  dead: "bg-gray-400 text-white",
};

const DESC =
  "Ranks every POI by tap count and assigns a temperature tier. Hot POIs (top 10%) are star attractions; dead POIs (bottom 30%) may need repositioning, better imagery, or removal.";

export function POIHeatmap({ data }: { data: POIHeatmapItem[] }) {
  if (data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>POI Engagement Heatmap</CardTitle>
          <CardDescription>{DESC}</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">No POI interaction data in this period.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>POI Engagement Heatmap</CardTitle>
        <CardDescription>{DESC}</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-8">#</TableHead>
              <TableHead>POI</TableHead>
              <TableHead>Category</TableHead>
              <TableHead className="text-right">Taps</TableHead>
              <TableHead className="text-right">Tier</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((item, i) => (
              <TableRow key={item.poiId}>
                <TableCell className="text-muted-foreground">{i + 1}</TableCell>
                <TableCell className="font-medium">{item.poiName}</TableCell>
                <TableCell>{item.category}</TableCell>
                <TableCell className="text-right">{item.count.toLocaleString()}</TableCell>
                <TableCell className="text-right">
                  <Badge className={TIER_COLORS[item.tier]}>{item.tier}</Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
